var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"min-vh-50"},[_c('h2',{staticClass:"page-title mb-5"},[_vm._v(" Your Current Plan ")]),_c('p',{staticClass:"text-[16px]"},[_vm._v(" You are on the "),_c('b',{staticClass:"font-italic",domProps:{"textContent":_vm._s(_vm.plan)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }